import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { useNavigate } from 'react-router-dom';
import girlAndDog from 'assets/girl_and_dog.png';

export default function PageNotFound() {
  const navigate = useNavigate();

  return (
    <Box
      component="div"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        bgcolor: 'background.default',
        px: 2,
        textAlign: 'center',
      }}
    >
      <Box
        component="img"
        src={girlAndDog}
        alt="Girl and Dog"
        sx={{
          maxWidth: 300,
          width: '100%',
          mb: 4,
        }}
      />
      <Typography variant="h3" gutterBottom>
        Oops! You’ve wandered off the trail.
      </Typography>
      <Typography variant="subtitle1" color="text.secondary" sx={{ mb: 4 }}>
        We can’t seem to find the page you’re looking for. But hey, this pup is here to keep you company!
      </Typography>
      <Button variant="contained" size="large" onClick={() => window.location.href = 'https://squadintouch.com'}>
        Take me back home
      </Button>
    </Box>
  );
}
